import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { StatusDot, type StatusDotProps } from './StatusDot';

export interface LegendItem {
  status: NonNullable<StatusDotProps['status']>;
  label: ReactNode;
}

export interface LegendProps {
  items: readonly LegendItem[];
  className?: string;
}

/**
 * Legenda kolorow statusow — „Zakończony / W trakcie / Zaplanowany / Walkower / Krecz”
 * spod drabinki i siatki kortow.
 */
export function Legend({ items, className }: LegendProps) {
  return (
    <ul className={cn('flex flex-wrap items-center gap-x-5 gap-y-2', className)}>
      {items.map((item, index) => (
        <li key={index} className="text-fg-muted flex items-center gap-2 text-xs">
          <StatusDot status={item.status} />
          {item.label}
        </li>
      ))}
    </ul>
  );
}
